import React, { Component } from "react";
import translations from "./translations";

const DEFAULT_LANG = "tr";

export const LanguageContext = React.createContext({
  lang: DEFAULT_LANG,
  t: (key) => key,
  setLang: () => {},
});

function resolve(dict, key) {
  return key.split(".").reduce((acc, part) => {
    if (acc && Object.prototype.hasOwnProperty.call(acc, part)) return acc[part];
    return undefined;
  }, dict);
}

function getInitialLang() {
  try {
    const saved = window.localStorage.getItem("roomy_lang");
    if (saved === "tr" || saved === "en") return saved;
  } catch (e) {
    /* localStorage kapalı olabilir */
  }
  return DEFAULT_LANG;
}

export class LanguageProvider extends Component {
  constructor(props) {
    super(props);
    this.state = { lang: getInitialLang() };
    this.setLang = this.setLang.bind(this);
    this.t = this.t.bind(this);
  }

  componentDidMount() {
    document.documentElement.lang = this.state.lang;
  }

  setLang(lang) {
    if (lang !== "tr" && lang !== "en") return;
    try {
      window.localStorage.setItem("roomy_lang", lang);
    } catch (e) {
      /* yoksay */
    }
    document.documentElement.lang = lang;
    this.setState({ lang });
  }

  t(key) {
    const { lang } = this.state;
    const val = resolve(translations[lang], key);
    if (val !== undefined) return val;
    const fallback = resolve(translations.tr, key);
    return fallback !== undefined ? fallback : key;
  }

  render() {
    const value = { lang: this.state.lang, t: this.t, setLang: this.setLang };
    return (
      <LanguageContext.Provider value={value}>
        {this.props.children}
      </LanguageContext.Provider>
    );
  }
}

export function useLang() {
  return React.useContext(LanguageContext);
}

export default LanguageContext;
